import type { InputHTMLAttributes } from 'react';
import React from 'react';
import type { _Omit } from '@noths/polaris-dev-ts-recipes';

import * as styles from './Radio.styles';

export type RadioDialProps = _Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const Radio = (props: RadioDialProps) => (
  <input css={styles.input} {...props} type="radio" />
);
